import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Check, X, Layers } from "lucide-react";
import { api } from "@/lib/api";
import { PageTitle, Card, inputCls, GoldButton } from "@/admin/ui";

export const CategoriesManager = () => {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const load = () => api.get("/admin/categories").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    await api.post("/admin/categories", { name });
    setName(""); toast.success("Categoria criada"); load();
  };
  const saveEdit = async (id) => {
    await api.put(`/admin/categories/${id}`, { name: editName });
    setEditId(null); toast.success("Atualizada"); load();
  };
  const remove = async (c) => {
    if (!window.confirm(`Excluir "${c.name}"?`)) return;
    await api.delete(`/admin/categories/${c.id}`); toast.success("Excluída"); load();
  };

  return (
    <div data-testid="admin-categories">
      <PageTitle title="Categorias" subtitle={`${items.length} categorias`} />
      <Card className="mb-6 flex gap-3">
        <input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Nova categoria..." className={inputCls} data-testid="category-input" />
        <GoldButton onClick={add} data-testid="category-add"><Plus className="w-4 h-4 inline mr-1" /> Adicionar</GoldButton>
      </Card>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((c) => (
          <Card key={c.id} className="flex items-center justify-between" data-testid={`category-${c.id}`}>
            {editId === c.id ? (
              <input value={editName} onChange={(e) => setEditName(e.target.value)} className={inputCls} autoFocus />
            ) : (
              <span className="flex items-center gap-2 text-white font-medium"><Layers className="w-4 h-4 text-[#F5C542]" /> {c.name}</span>
            )}
            <div className="flex gap-1 ml-2">
              {editId === c.id ? (
                <>
                  <button onClick={() => saveEdit(c.id)} className="p-2 text-[#00FF41]"><Check className="w-4 h-4" /></button>
                  <button onClick={() => setEditId(null)} className="p-2 text-white/50"><X className="w-4 h-4" /></button>
                </>
              ) : (
                <>
                  <button onClick={() => { setEditId(c.id); setEditName(c.name); }} className="p-2 text-white/60 hover:text-[#F5C542]"><Pencil className="w-4 h-4" /></button>
                  <button onClick={() => remove(c)} className="p-2 text-white/60 hover:text-[#FF3B30]"><Trash2 className="w-4 h-4" /></button>
                </>
              )}
            </div>
          </Card>
        ))}
        {items.length === 0 && <Card className="col-span-full text-center py-10 text-white/40">Nenhuma categoria.</Card>}
      </div>
    </div>
  );
};
